import { ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';
import { getColors } from '../tokens/getColors';
import { typography } from '../tokens/typography';

export interface PageLayoutV2Props {
  title: string;
  subtitle?: string;
  headerActions?: ReactNode;
  backButton?: ReactNode;
  children: ReactNode;
}

const SIDE_PADDING = 100;

const useStyles = makeStyles()(theme => {
  const c = getColors(theme.palette.mode);
  return {
    root: {
      backgroundColor: c.background.page,
      minHeight: '100vh',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
    },
    content: {
      position: 'relative',
      padding: `0 ${SIDE_PADDING}px 32px`,
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    backButtonContainer: {
      paddingTop: 24,
      paddingLeft: SIDE_PADDING,
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      padding: '40px 0 32px',
    },
    headerText: {
      flex: 1,
    },
    title: {
      fontFamily: typography.fontFamilyCorpoATitle,
      fontSize: '3rem',
      fontWeight: 400,
      lineHeight: 1.1,
      color: c.text.primary,
      margin: 0,
    },
    subtitle: {
      fontFamily: typography.fontFamilyCorpoSText,
      fontSize: '1rem',
      color: c.text.secondary,
      marginTop: 10,
    },
    headerActions: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    },
  };
});

export const PageLayoutV2 = ({
  title,
  subtitle,
  headerActions,
  backButton,
  children,
}: Readonly<PageLayoutV2Props>) => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      {backButton && (
        <div className={classes.backButtonContainer}>{backButton}</div>
      )}
      <div className={classes.content}>
        <div className={classes.header}>
          <div className={classes.headerText}>
            <h1 className={classes.title}>{title}</h1>
            {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
          </div>
          {headerActions && (
            <div className={classes.headerActions}>{headerActions}</div>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};
